const initialstate = {
  no: 0,
  notifyData: {
    open: false,
    message: "",
    duration: 6000,
    severity: "success",
    multipleSentenses: false,
    timerOn: true
  },
  bikeNotifyData: {
    open: false,
    message: "",
    duration: 6000,
    severity: "success",
  },
};

// reducers.js
const commonReducer = (state = initialstate, action) => {
  switch (action.type) {
    case "DISPLAY_NOTIFICATION":
      const { open, message, duration, severity, multipleSentenses, timerOn } = action.data;
      return {
        ...state,
        notifyData: {
          ...state.notifyData,
          open: open,
          message: message ? message : state.notifyData.message,
          duration: duration ? duration : state.notifyData.duration,
          severity: severity ? severity : state.notifyData.severity,
          multipleSentenses: multipleSentenses ? multipleSentenses : state.notifyData.multipleSentenses,
          timerOn: timerOn == false ? timerOn : true
        },
      };
    case "BIKE_DISPLAY_NOTIFICATION":
      const { open: openValue, message: messageValue, duration: durationValue, severity: severityValue } = action.data;
      return {
        ...state,
        bikeNotifyData: {
          ...state.bikeNotifyData,
          open: openValue,
          message: messageValue ? messageValue : state.bikeNotifyData.message,
          duration: durationValue ? durationValue : state.bikeNotifyData.duration,
          severity: severityValue ? severityValue : state.bikeNotifyData.severity,
        },
      };
    default:
      return state;
  }
};

export default commonReducer;

